// error messages

export const requiredField = (fieldName: string) => {
  return `Полето "${fieldName}" е задължително`;
};

export const fieldMaxLength = (fieldName: string, maxLength: number) => {
  return `Полето "${fieldName}" не може да е по-дълго от ${maxLength} символа.`;
};

export const fieldMinLength = (fieldName: string, minLength: number) => {
  return `Полето "${fieldName}" не може да е по-малко от ${minLength} символа.`;
};

export const fieldMaxNumber = (fieldName: string, maxNumber: number) => {
  return `Полето "${fieldName}" не може да бъде повече от ${maxNumber}.`;
};

export const fieldAtLeastOneRequired = (fieldName: string) => {
  return `Поне един ${fieldName} трябва бъде избран.`;
};

export const fieldMustBePositive = (fieldName: string) => {
  return `Полето "${fieldName}" трябва да има положителна стойност.`;
};

export const fieldMustBeZeroOrHigher = (fieldName: string) => {
  return `Полето "${fieldName}" не може да бъде отрицателно.`;
};

export const fieldMustBeANumber = (fieldName: string) => {
  return `Полето "${fieldName}" трябва да бъде число.`;
};

export const fieldValuesDoesNotMatch = (
  fieldName1: string,
  fieldName2: string
) => {
  return `Стойностите на поле '${fieldName1}' и '${fieldName2}' не съвпадат.`;
};

export const emailMustBeValidEmail = () => {
  return `Имейлът трябва да е валиден имейл.`;
};

// validations

export const nullableNumber = (value: string, originalValue: string) =>
  originalValue === "" ? null : value;
